export const ID = 'ID';
export const DECISION_SUCCESS = 'SUCCESS';
export const DECISSION_FAILURE = 'FAIL';
